module.exports = __webpack_public_path__ + "static/media/alexia-gold-logo-lg.5424bec8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alexia-gold-logo-lg.png
// module id = 1698
// module chunks = 0